export class DownTimeTrackingRequest{
    downtimeTrackingId:number;
    versionFlag: number;
    isActive:boolean;
    constructor(downTimeTrackingId:number,isActive:boolean){
        this.downtimeTrackingId=downTimeTrackingId;
        this.isActive=isActive;
    }
}